import type { GlobalCollectionId, GlobalIndexId, GlobalNamespaceId, GlobalPrimitiveFieldId } from '#layers/data-model/types/schema';
import * as z from 'zod/v4-mini';
import { ApiSafeString, DbSafeString, notEmpty } from '#layers/base';
import { INDEX_KINDS } from '#layers/data-model/constants/schema/schema';

export const IndexKindSchema = z.enum(INDEX_KINDS);

export const GlobalCollectionIdSchema: z.ZodMiniType<GlobalCollectionId> = z.uuid() as any;
export const GlobalPrimitiveFieldIdSchema: z.ZodMiniType<GlobalPrimitiveFieldId> = z.uuid() as any;
export const GlobalIndexIdSchema: z.ZodMiniType<GlobalIndexId> = z.uuid() as any;
export const GlobalNamespaceIdSchema: z.ZodMiniType<GlobalNamespaceId> = z.uuid() as any;

// TODO auto generate these based on the monospace schema
export const MonospaceIndexSchema = z.object({
	id: GlobalIndexIdSchema,
	collectionId: GlobalCollectionIdSchema,
	dbName: DbSafeString,
	kind: IndexKindSchema,
});

export const MonospacePrimitiveFieldMetaSchema = z.object({
	displayName: z.nullable(z.string({ error: '$t:validation.not_empty' }).check(notEmpty)),
	description: z.nullable(z.string()),

	typeTemplateId: z.nullable(z.string()),
	typeOptions: z.nullable(z.looseObject({})),

	inputId: z.nullable(z.string()),
	inputOptions: z.nullable(z.looseObject({})),

	isHidden: z.boolean(),
});

export const MonospacePrimitiveFieldSchema = z.object({
	id: GlobalPrimitiveFieldIdSchema,
	dbName: DbSafeString,
	apiName: ApiSafeString,

	type: z.looseObject({}),
	defaultValue: z.nullable(z.looseObject({})),

	isNullable: z.boolean(),
	isList: z.boolean(),

	meta: z.nullable(MonospacePrimitiveFieldMetaSchema),
	// TODO more properties
});
